<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">{{$t('quizzes.header')}}</h1>

        <v-row>
            <v-col>
                <v-text-field
                        v-model="keyword"
                        :label="$t('global.search')"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="QUIZZES"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{props.index+1}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0" @click="[$refs.confirm.dialog = true, selectedQuiz = props.item.id]">
                    <svg v-svg="'icon-start'" size="12" class="mr-1"></svg>
                    <span class="start">{{$t('quizzes.start')}}</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <confirm ref="confirm" :quiz_id="selectedQuiz"></confirm>
    </section>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Confirm from '@/components/Quizzes/Confirm';
    export default {
        components: { Confirm },
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                selectedQuiz: null,
                keyword: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: this.$t('quizzes.name'), sortable: false, value: 'course_name'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
            }
        },

        computed: mapGetters(['QUIZZES']),

        mounted(){
            this.getData();
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData();
                }, 300);
            }
        },

        methods: {
            getData(){
                this.loadingRequest = true;
                this.$store.dispatch('GET_QUIZZES', {params: {keyword: this.keyword}})
                    .then(() => this.loadingRequest = false);
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/pages/tablePages";
    @import "../../scss/pages/Quizzes/index";
</style>